import { SVGProps, Ref, forwardRef } from 'react';

export const DzenSolidSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.044 23.001h-.088c-4.368 0-6.922-.44-8.701-2.184C1.423 18.95 1 16.413 1 12.062v-.123c0-4.35.423-6.905 2.255-8.755C5.05 1.44 7.588 1 11.957 1h.088c4.351 0 6.905.44 8.7 2.184C22.577 5.052 23 7.588 23 11.939v.123c0 4.352-.423 6.905-2.255 8.755-1.796 1.744-4.332 2.184-8.701 2.184m8.185-11.324a.16.16 0 0 1 .152.157h-.002v.35a.157.157 0 0 1-.151.158c-3.008.114-4.836.496-6.118 1.777-1.28 1.28-1.662 3.107-1.778 6.109a.16.16 0 0 1-.157.152h-.352a.157.157 0 0 1-.157-.152c-.115-3.002-.498-4.828-1.778-6.109s-3.11-1.663-6.117-1.777a.16.16 0 0 1-.152-.157v-.351c0-.085.068-.155.152-.157 3.007-.114 4.836-.496 6.117-1.778 1.283-1.283 1.665-3.116 1.78-6.128a.16.16 0 0 1 .156-.152h.351c.085 0 .155.068.157.152.114 3.013.496 4.845 1.78 6.128 1.28 1.28 3.11 1.664 6.117 1.778"
                fill="currentColor"
            />
        </g>
    </svg>
));
DzenSolidSize24Glyph.displayName = 'DzenSolidSize24Glyph';
